// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9bfdb31d","453":"28e405c2","732":"ffcf0ecd","977":"7e146ffb"}[chunkId] + ".chunk.js";
};